import { formatISO, parse } from "date-fns";
import { parseISO, format as baseFormat } from "date-fns";
import defaultLocale from "date-fns/locale/cs";
import { TimePrecision } from "./timePicker";

export const formatDateTimeISO = formatISO;
export const formatDateISO = (date: Date) => formatISO(date, { representation: "date" });
export const formatTimeISO = (date: Date) => formatISO(date, { representation: "time" });

// Formáty data, které jsem viděl používat napříč aplikacemi
// TODO: lepší jména konstant
export enum DateFormat {
    SHORT = "SHORT", // 1.2.1999
    SHORT_SPACES = "SHORT_SPACES", // 1. 2. 1999
    LONG = "LONG", // 01.02.1999
    LONG_SPACES = "LONG_SPACES", // 01. 02. 1999
    MONTH = "MONTH", // 5/2021
}

export interface FormatOptions {
    dateFormat?: DateFormat;
    timeFormat?: TimePrecision;
    locale?: any; // TODO: typ
}

function getPattern(dateFormat?: DateFormat, timeFormat?: TimePrecision | "hour") {
    let patern = "";
    if (dateFormat) {
        switch (dateFormat) {
            case DateFormat.LONG:
                patern += "dd.MM.yyyy";
                break;
            case DateFormat.LONG_SPACES:
                patern += "dd. MM. yyyy";
                break;
            case DateFormat.MONTH:
                patern += "M/yyyy";
                break;
            case DateFormat.SHORT:
                patern += "d.M.y";
                break;
            case DateFormat.SHORT_SPACES:
                patern += "d. M. y";
                break;
        }
    }
    if (dateFormat && timeFormat) {
        patern += " ";
    }
    if (timeFormat) {
        switch (timeFormat) {
            case TimePrecision.MINUTE:
                patern += "HH:mm";
                break;
            case TimePrecision.SECOND:
                patern += "HH:mm:ss";
                break;
            case TimePrecision.MILLISECOND:
                patern += "HH:mm:ss.SSS";
                break;
            case "hour": // TODO;
                patern += "HH";
                break;
        }
    }
    return patern;
}

export function format(date: Date | string, options: FormatOptions): string {
    if (typeof date === "string") {
        date = parseISO(date); // Pokud je datum zadané jako string v ISO formátu
    }
    const { dateFormat, timeFormat, locale = defaultLocale } = options;
    const pattern = getPattern(dateFormat, timeFormat); // Vygeneruje formátovací pattern dle https://date-fns.org/docs/format
    return baseFormat(date, pattern, { locale });
}

export function getJavaDate(date?: Date) {
    if (!date) {
        return null;
    }

    const localDate = new Date(+date);
    localDate.setMinutes(localDate.getMinutes() + -localDate.getTimezoneOffset());
    return localDate.toISOString().split("T")[0];
}

export function getJavaDateTime(date?: Date) {
    if (!date) {
        return null;
    }

    const localDate = new Date(+date);
    localDate.setMinutes(localDate.getMinutes() + -localDate.getTimezoneOffset());
    return localDate.toISOString().split(".")[0];
}

export function stringInputParseDate(date: string) {
    const r = date.trim();
    if (r === "") {
        return null;
    }
    let res: boolean | Date = false;
    for (let format of ["ddMMyyyy", "dd.MM.yyyy", "dd. MM. yyyy"]) {
        const parsed = parse(r, format, new Date());
        if (parsed instanceof Date && !isNaN(parsed as any)) {
            res = parsed;
            break;
        }
    }
    return res;
}

export function stringInputParseDateTime(date: string) {
    const r = date.trim();
    if (r === "") {
        return null;
    }
    let res: boolean | Date = false;
    for (let format of [
        "ddMMyyyy",
        "dd.MM.yyyy",
        "dd. MM. yyyy",
        "dd.MM.yyyy HH",
        "dd. MM. yyyy HH",
        "dd.MM.yyyy HH:mm",
        "dd. MM. yyyy HH:mm",
    ]) {
        const parsed = parse(r, format, new Date());
        if (parsed instanceof Date && !isNaN(parsed as any)) {
            res = parsed;
            break;
        }
    }
    return res;
}

export function stringInputFormatDate(date: Date) {
    if (date === null || date === undefined) {
        return null;
    }
    return date
        ? format(date, {
              timeFormat: undefined,
              dateFormat: DateFormat.LONG_SPACES,
          })
        : null;
}

export function stringInputFormatDateTime(date: Date) {
    if (date === null || date === undefined) {
        return null;
    }
    return date
        ? format(date, {
              timeFormat: TimePrecision.MINUTE,
              dateFormat: DateFormat.LONG_SPACES,
          })
        : null;
}

export function stringInputFormatMonth(date: Date) {
    if (date === null || date === undefined) {
        return null;
    }
    return date
        ? format(date, {
              timeFormat: undefined,
              dateFormat: DateFormat.MONTH,
          })
        : null;
}

export function stringInputParseMonthDate(date: string, endOfMonth: boolean) {
    const r = date.trim();
    if (r === "") {
        return null;
    }

    const value = r.replace(/\s\s+/g, " ");

    let res: boolean | Date = false;
    for (let format of [
        "M. yyyy",
        "MM. yyyy",
        "M.yyyy",
        "MM.yyyy",
        "M/yyyy",
        "MM/yyyy",
        "M / yyyy",
        "MM / yyyy",
        "M, yyyy",
        "MM, yyyy",
        "M,yyyy",
        "MM,yyyy",
        "M yyyy",
        "MM yyyyy",
        "Myyyy",
        "MMyyyyy",
        "M. yy",
        "M, yy",
        "M yy",
        "M",
    ]) {
        try {
            let parsed = parse(value, format, new Date());
            console.log(date, value, format, parsed);

            if (parsed instanceof Date && !isNaN(parsed as any)) {
                // Rok - krátký formát
                if (parsed.getFullYear() < 100) {
                    let century = new Date().getFullYear();
                    century = Math.round(century / 100) * 100;
                    console.log("century", century, "->", century + parsed.getFullYear());
                    res = new Date(century + parsed.getFullYear(), parsed.getMonth(), parsed.getDay());
                } else {
                    res = parsed;
                }

                if (endOfMonth) {
                    // Poslední den se dělá jako den 0 následující měsíc 😃
                    res = new Date(res.getFullYear(), res.getMonth() + 1, 0);
                } else {
                    res = new Date(res.getFullYear(), res.getMonth(), 1);
                }
                break;
            }
        } catch (e) {}
    }
    console.log("out", res);
    return res;
}
